export default __webpack_public_path__ + "imgs/toLove02.a098a43.jpeg";